<template>
  <div class="outmain">
    <div class="shuju_title mar_b20">
      <div class="shuju_title_text">
        <span>{{ $t('order.cancelReason.listTitle') }}</span>
      </div>
    </div>
    <el-button type="primary" class="mar_b20" @click="handleSeeEdit(false)">{{ $t('order.cancelReason.add') }}</el-button>
    <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="sort" :label="$t('common.sort')" align="center"></el-table-column>
      <el-table-column prop="title" :label="$t('order.cancelReason.reason')" align="center"></el-table-column>
      <el-table-column prop="createdAt" :label="$t('common.addTime')" align="center"></el-table-column>
      <el-table-column :label="$t('common.status')" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.display" active-color="#13ce66" @change="changeType($event,scope.row.id)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.operation')" width="300" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSeeEdit(scope.row.id)">{{ $t('common.view') }}</el-button>
          <el-button type="text" @click="handleDelete(scope.row.id)">{{ $t('common.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" :current-page.sync="currentPage" @current-change="handleCurrentChange"></el-pagination>
    <add-edit-cancel ref="addEdit" v-if="dialogVisible" @callBack="callBack"></add-edit-cancel>
  </div>
</template>
<script>
import { agreementList, deleteRule } from '@/api/set.js';
import addEditCancel from './components/add-edit-cancel.vue';
export default {
  components: { addEditCancel },
  data() {
    return {
      listLoading: true,
      dialogVisible: false,
      orderInfo: {},
      selectRows: '',
      total: 0,
      currentPage: 1,
      formInline: {
        type: 5
      },
      list: []
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    loadingText() {
      return this.$t('common.loading');
    }
  },
  methods: {
    fetchData() {
      agreementList(this.formInline).then((res) => {
        if (res.code == 1) {
          this.total = res.count;
          this.list = res.data.map((item) => {
            item.display = item.display == 1 ? true : false;
            return item;
          });
          this.listLoading = false;
        }
      });
    },
    changeType(type, id) {
      deleteRule({ type: 'display', id, display: type ? 1 : 2 }).then((res) => {
        if (res.code == 1) {
          this.$baseMessage(res.msg, 'success');
        }
      });
    },
    handleSeeEdit(id) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addEdit.init(id);
      });
    },
    callBack() {
      this.dialogVisible = false;
      this.fetchData();
    },
    handleDelete(id) {
      this.$baseConfirm(this.$t('confirm.deleteOrder'), null, () => {
        deleteRule({ id: id, type: 5 }).then((res) => {
          if (res.code == 1) {
            this.$baseMessage(res.msg, 'success');
            this.fetchData();
          }
        });
      });
    },
    handleCurrentChange() {},
    setSelectRows() {}
  }
};
</script>
